import type { CognitoAuthStorage } from 'amazon-cognito-auth-js';

/**
 * In-memory `Storage` for `amazon-cognito-auth-js`. The SDK persists the ID,
 * access and refresh tokens through this object; its default is localStorage.
 * Backing it with a plain object keeps every Cognito token in JS heap only.
 *
 * Tradeoff: the store starts empty on every page load, so each reload or new
 * tab re-runs the Hosted-UI code grant. The Cognito web session cookie makes
 * that redirect silent, but it is a navigation round-trip per reload.
 */
class InMemoryCognitoStorage implements CognitoAuthStorage {
  private data: Record<string, string> = {};

  getItem(key: string): string | null {
    return Object.prototype.hasOwnProperty.call(this.data, key)
      ? this.data[key]
      : null;
  }

  setItem(key: string, value: string): void {
    this.data[key] = String(value);
  }

  removeItem(key: string): void {
    delete this.data[key];
  }
}

// Single shared instance: FederatedAuth constructs a new CognitoAuth on each
// mount, so they must share one store within the same page load.
export const cognitoMemoryStorage: CognitoAuthStorage =
  new InMemoryCognitoStorage();
